import { useCallback } from 'react';
import { EditorView } from 'prosemirror-view';

import { closeDialog, insertEmoji } from './utils';

export const useMenuItemClick = (view?: EditorView, match?: string) => {
  return useCallback(
    (item: any) => {
      if (view) {
        const charactersToReplace = (match?.length || 0) + 1;
        const to = view.state.selection.$anchor.pos;
        const from = to - charactersToReplace;

        closeDialog(view.state, view.dispatch);

        insertEmoji(view, item.native, from, to);
        view.focus();
      }
    },
    [view, match],
  );
};
